import React from 'react';
import { cn } from '../../lib/utils';

const FundingPanel = ({ title, subtitle, children, className, actions }) => (
  <section className={cn('fundgenius-hq-panel p-5', className)}>
    {(title || actions) ? (
      <div className="mb-4 flex flex-wrap items-start justify-between gap-3">
        <div>
          {title ? <h2 className="text-lg font-semibold text-[var(--fg-text)]">{title}</h2> : null}
          {subtitle ? <p className="mt-1 text-sm text-[var(--fg-muted)]">{subtitle}</p> : null}
        </div>
        {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
      </div>
    ) : null}
    {children}
  </section>
);

export default FundingPanel;
